import { useEffect } from 'react'
import { useAuthStore } from '@/store/useAuthStore'
import { useTokenStore } from '@/store/useTokenStore'
import { authApi } from '@/rest/modules/auth-api'

export const useAuthInit = () => {
  const { setUser, setLoading } = useAuthStore()

  useEffect(() => {
    const initializeAuth = async () => {
      setLoading(true)
      try {
        const token = useTokenStore.getState().token
        if (token) {
          const user = await authApi.getProfile()
          if (user) {
            setUser(user)
          } else {
            useTokenStore.getState().clearToken()
          }
        }
      } catch (error) {
        console.error('Auth initialization error:', error)
        useTokenStore.getState().clearToken()
      } finally {
        setLoading(false)
      }
    }

    initializeAuth()
  }, [setUser, setLoading])
}